import { render, staticRenderFns } from "./Superset.vue?vue&type=template&id=4732e566&"
import script from "./Superset.vue?vue&type=script&lang=js&"
export * from "./Superset.vue?vue&type=script&lang=js&"
import style0 from "./Superset.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports